import { Link as RouterLink } from "react-router-dom";
import {
    AppBar,
    Box,
    Hidden,
    IconButton,
    Toolbar,
    useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Logo from "src/components/Logo";
import FirstAndLastMileNotifications from "./FirstAndLastMileNotifications";
import { CreditsAndPlansDetails, ElevationScroll } from "../components";
import ProfileAvatar from "../components/ProfileAvatar";
import { AppBarLocalizationMenu } from "src/services/public/layout/components/navigation-bar/components/localization";

export default function FirstAndLastMileAppBar({ toggleDrawer, merchant, ...rest }) {

    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

    return (
        <ElevationScroll>
            <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Toolbar>
                    <Hidden lgUp>
                        <IconButton color="inherit" onClick={toggleDrawer} size="large">
                            <MenuIcon />
                        </IconButton>
                    </Hidden>
                    <RouterLink to="/">
                        <Logo
                            type="light"
                            height={isMobile ? 30 : 40}
                            style={{
                                marginInlineStart: isMobile ? "2vw" : "4vw" /*128 - 16 - 36 - 10*/,
                                marginTop: isMobile ? 7 : undefined,
                            }}
                        />
                    </RouterLink>
                    <Box sx={{ flexGrow: 1 }} />
                    <CreditsAndPlansDetails />
                    <FirstAndLastMileNotifications />
                    <ProfileAvatar />
                    <AppBarLocalizationMenu reload={true} sx={{ display: { xs: 'none', md: 'inline-block' } }} />
                </Toolbar>
            </AppBar>
        </ElevationScroll>
    )
}